/*
  NodeSelector.jsx
*/

// Npm.
import React from 'react';

// Util.
import { DEFAULT_NODE_COLOR } from '../utils/constants';

// Components.
import Autocomplete from './Autocomplete';

// Makes.
import { makeStyles } from '../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  nodeIcon: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: 4,
  },
}));

// Helpers.
function getNodeColor(node) {
  return node?._botech?.color || DEFAULT_NODE_COLOR;
}

/**
 * Selector for Nodes.
 */
export default function NodeSelector({
  nodes,
  multiple = false,
  ...rest
}) {

  const classes = useStyles();

  return (
    <Autocomplete
      options={nodes}
      multiple={multiple}
      disableCloseOnSelect={multiple}
      getOptionLabel={node => `${node._botech?.label || 'untitled'} <${node.id}>`}
      getOptionValue={node => node.id || null}
      getOptionIcon={node => (
        <span
          className={classes.nodeIcon}
          style={{ backgroundColor: getNodeColor(node) }}
        />
      )}
      {...rest}
    />
  );
};
